import { gql } from "@apollo/client";

export const getOrganizationMetadata = gql`
    query getOrganizationMetadata($organizationId: ID!) {
        getOrganizationMetadata(input: { organizationId: $organizationId }) {
            organizationMetadata {
                id
                name
                type
            }
        }
    }
`;
